// extracted by mini-css-extract-plugin
module.exports =  {"root":"MiTVfBIYbTWkyx7IRcBT","small":"MtEx8oOY6FNZtthbPmdy"};